import { WaveFile } from "wavefile";

export const generateMetronomeTrack = async (
  tempo,
  duration,
  soundUrl,
  accentSoundUrl,
  beatsPerMeasure
) => {
  const sampleRate = 44100;
  const totalSamples = sampleRate * duration;
  const interval = Math.floor((60 / tempo) * sampleRate); // Intervalo en muestras entre clics

  // Crear un contexto de audio para decodificar los archivos de sonido
  const audioContext = new AudioContext();

  // Fetch y decodificar el sonido normal
  const response = await fetch(soundUrl);
  const arrayBuffer = await response.arrayBuffer();
  const normalSound = await audioContext.decodeAudioData(arrayBuffer);

  // Fetch y decodificar el sonido de acento
  const accentResponse = await fetch(accentSoundUrl);
  const accentArrayBuffer = await accentResponse.arrayBuffer();
  const accentSound = await audioContext.decodeAudioData(accentArrayBuffer);

  // Obtener datos de audio
  const normalSamples = normalSound.getChannelData(0); // Canal izquierdo
  const accentSamples = accentSound.getChannelData(0); // Canal izquierdo
  const normalClickDuration = normalSamples.length;
  const accentClickDuration = accentSamples.length;

  // Crear buffer para la pista final
  const audioBuffer = new Float32Array(totalSamples);

  // Insertar clics en los intervalos correspondientes
  let beatCount = 0;
  for (let start = 0; start < totalSamples; start += interval) {
    const isAccent = beatCount % beatsPerMeasure === 0; // Acentuar la primera nota del compás
    const samples = isAccent ? accentSamples : normalSamples;
    const clickDuration = isAccent ? accentClickDuration : normalClickDuration;

    for (let i = 0; i < clickDuration; i++) {
      const sampleIndex = start + i;
      if (sampleIndex < totalSamples) {
        audioBuffer[sampleIndex] += samples[i];
      }
    }

    beatCount++;
  }

  // Normalizar el buffer
  let maxAmplitude = 0;
  for (let i = 0; i < audioBuffer.length; i++) {
    const absValue = Math.abs(audioBuffer[i]);
    if (absValue > maxAmplitude) {
      maxAmplitude = absValue;
    }
  }

  for (let i = 0; i < audioBuffer.length; i++) {
    audioBuffer[i] /= maxAmplitude;
  }

  // Eliminar espacio previo al primer sonido significativo
  const threshold = 0.02; // Define un umbral para identificar el sonido
  let firstSoundIndex = 0;

  for (let i = 0; i < audioBuffer.length; i++) {
    if (Math.abs(audioBuffer[i]) > threshold) {
      firstSoundIndex = i;
      break;
    }
  }

  // Crear un nuevo buffer sin el espacio inicial
  const trimmedBuffer = audioBuffer.slice(firstSoundIndex);

  // Convertir a Int16 para exportar como WAV
  const int16Buffer = new Int16Array(trimmedBuffer.length);
  for (let i = 0; i < trimmedBuffer.length; i++) {
    int16Buffer[i] = Math.max(-1, Math.min(1, trimmedBuffer[i])) * 32767;
  }

  // Crear archivo WAV usando wavefile
  const wav = new WaveFile();
  wav.fromScratch(1, sampleRate, "16", int16Buffer);

  // Generar un Blob y descargar
  const blob = new Blob([wav.toBuffer()], { type: "audio/wav" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `metronome_${tempo}bpm_${duration}s_accent.wav`;
  a.click();
};
